import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { TAPPAY } from '../../libs/constants'
import { formatNumber } from '../../libs/utils'
import { isPeriodicPaymentSelector } from '../../reducers/itemEntryReducer'
import BottomSheet from '../babu/BottomSheet'
import BulletButton from '../babu/BulletButton'
import TableRow from '../babu/TableRow'
import BottomButtonArea from '../common/BottomButtonArea'
import ErrorScreenTopArea from '../common/ErrorScreenTopArea'
import LoadingOverlay from '../common/LoadingOverlay'
import NavBar from '../common/NavBar'
import { ga4Event } from '../libs/ga4'
import TapPayFormFields from './TapPayFormFields'

const checkPeriodic = isPeriodicPayment =>
  isPeriodicPayment || isPeriodicOverdueUrl()

const isPeriodicOverdueUrl = () => {
  const url = window.location.href
  const regex = /buyer\/orders\//
  return regex.exec(url) !== null
}

function TapPayFormContainer(props) {
  const [canSubmit, setCanSubmit] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const { price } = props

  const isPeriodicPayment = useSelector(state =>
    isPeriodicPaymentSelector(state.itemEntry),
  )

  const isPeriodic = useMemo(
    () => checkPeriodic(isPeriodicPayment),
    [isPeriodicPayment],
  )

  const [agreePeriodic, setAgreePeriodic] = useState(false)
  const [openBottomSheet, setOpenBottomSheet] = useState(false)

  const disabled = submitted || !canSubmit || (isPeriodic && !agreePeriodic)

  return (
    <div className="full-vh flex flex-col">
      <NavBar />
      <div className="container mt-navbarSpacing">
        <p className="babu-text pt-l">{`刷卡金額為 NT$${formatNumber(
          price,
        )}`}</p>
        <h2 className="babu-text-subtitle mt-xxs mb-l">輸入信用卡資訊</h2>
      </div>
      <TapPayFormFields submitted={submitted} setCanSubmit={setCanSubmit} />
      <div className="container mb-30 flex-1">
        {isPeriodic ? (
          <div className="babu-card px-0 mb-m">
            <TableRow
              compact
              divided={false}
              content="我同意系統每月定期扣款"
              accessoryType={{
                checked: agreePeriodic,
                onChange: () => setAgreePeriodic(!agreePeriodic),
              }}
            />
          </div>
        ) : null}
        <BulletButton
          variant="solid"
          className="mt-xxl"
          disabled={disabled}
          onClick={() => {
            if (isPeriodic && price === 0) {
              setOpenBottomSheet(true)
            } else {
              if (!disabled) {
                setSubmitted(true)
                ga4Event(
                  isPeriodic
                    ? 'slash_creditcard_monthlypay'
                    : 'slash_creditcard',
                )
                props.onCheckout()
              }
            }
          }}>
          確認並付款
        </BulletButton>
      </div>
      <div className="py-m">
        <div className="container flex items-center">
          <div className="pr-xs">
            <img
              alt="tappay_icon"
              src="/images/payment/tappay_icon.png"
              style={{ width: 60, height: 60 }}
            />
          </div>
          <div className="flex-1">
            <small className="text-text500 text-xs">{TAPPAY.TERMS}</small>
          </div>
        </div>
      </div>
      <BottomSheet open={openBottomSheet} setOpen={setOpenBottomSheet}>
        <div className="container pt-m pb-xl flex flex-col items-center">
          <img
            alt="credit_card"
            src="/images/credit-card@3x.png"
            srcSet="/images/credit-card.png 1x, /images/credit-card@2x.png 2x"
            style={{ width: 328, height: 170 }}
          />
          <p className="babu-text py-4 text-center text-2xl">卡片驗證</p>
          <p className="babu-text mb-m">
            此信用卡將作為後續款項的支付方式，為了保障後續交易的安全，接下來會進行
            1 元的試刷。
          </p>
          <BulletButton
            variant="solid"
            onClick={() => {
              setSubmitted(true)
              props.onCheckout()
              setOpenBottomSheet(false)
            }}>
            繼續
          </BulletButton>
          <div className="h-2"></div>
          <BulletButton
            variant="light"
            onClick={() => setOpenBottomSheet(false)}>
            取消
          </BulletButton>
        </div>
      </BottomSheet>
    </div>
  )
}

export default function TapPayPayment(props) {
  const { loadSDK, onCancel } = props
  const sdkLoaded = useSelector(state => state.tapPay.sdkLoaded)

  useEffect(() => {
    loadSDK()
  }, [loadSDK])

  if (!sdkLoaded) {
    return <LoadingOverlay />
  }

  if (sdkLoaded === 'error') {
    return (
      <>
        <NavBar />
        <ErrorScreenTopArea title="信用卡系統連線失敗，請稍候再試" />
        <BottomButtonArea onClick={onCancel}>取消</BottomButtonArea>
      </>
    )
  }

  return (
    <TapPayFormContainer
      price={props.price}
      onCheckout={props.onCheckout}
      onCancel={onCancel}
      toPurchaseLoginPage={props.toPurchaseLoginPage}
    />
  )
}
